import type { TrainingQuestionDef } from '@hcc/types';
import { QuestionCommonFields } from './QuestionCommonFields';

type TrueFalseQuestion = Extract<TrainingQuestionDef, { type: 'true_false' }>;

/**
 * True/false editor: the common prompt + points, plus a pick of which answer
 * is correct. The prompt is the statement the learner judges.
 */
export function TrueFalseQuestionEditor({
  question,
  onChange,
  graded = true,
}: {
  question: TrueFalseQuestion;
  onChange: (next: TrueFalseQuestion) => void;
  /** False hides the points box (an unmarked assessment). */
  graded?: boolean;
}) {
  return (
    <div className="space-y-3">
      <QuestionCommonFields
        prompt={question.prompt}
        points={question.points}
        onPrompt={(prompt) => onChange({ ...question, prompt })}
        onPoints={(points) => onChange({ ...question, points })}
        graded={graded}
        promptLabel="Statement"
      />
      <div className="space-y-2">
        <span className="text-sm font-medium text-fg-muted">Correct answer</span>
        <div className="grid grid-cols-2 gap-2">
          {([true, false] as const).map((val) => {
            const selected = question.correct === val;
            return (
              <button
                key={String(val)}
                type="button"
                aria-pressed={selected}
                onClick={() => onChange({ ...question, correct: val })}
                className={`min-h-[44px] rounded-token-sm border px-4 py-2 text-sm font-medium transition-colors ${
                  selected
                    ? 'border-accent bg-accent/10 text-fg'
                    : 'border-line-strong/20 bg-surface text-fg-muted hover:bg-surface-2'
                }`}
              >
                {val ? 'True' : 'False'}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
